import { Expose, Type } from 'class-transformer'

import { Product } from './Product'
import { ParcelOrder } from './ParcelOrder'
import { Sku } from './Sku'

export class ParcelOrderUnit {
  get guid() {
    return this.sku?.guid
  }

  @Type(() => ParcelOrder)
  order?: ParcelOrder

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Expose({ name: 'num_units' })
  numUnits?: string

  @Expose({ name: 'num_picked' })
  numPicked?: string

  @Expose({ name: 'num_fulfilled' })
  numFulfilled?: string

  status?: string
}
